import VueZwToolbarPlugin from './zw-toolbar.vue'
const zwToolbarPlugin = {
    install: function(Vue) {
        Vue.component(VueZwToolbarPlugin.name, VueZwToolbarPlugin)
    }
}
// global 情况下 自动安装
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(zwToolbarPlugin)
}
// 导出模块
export default zwToolbarPlugin


// WEBPACK FOOTER //
// ./src/lib/zw-toolbar.js